/**
 * Load Selectric and attach to jQuery.
 * Webpack's UMD transform runs the plugin factory with jQuery when this module loads,
 * so the plugin attaches as a side effect. We just need to load jquery first, then selectric.
 */
require('jquery');
require('selectric');
